module.exports = __webpack_public_path__ + "google-logo-8f3e2e74a7b9d91fc7e2596d780de264.webp";